$(document).ready(function () {
    const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

    function setCookie(name, value, days = 30) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + "=" + encodeURIComponent(value) +
            "; expires=" + expires + "; path=/";
    }

    function getCookie(name) {
        const match = document.cookie.match(
            new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? decodeURIComponent(match[2]) : '';
    }

    const urlParams = new URLSearchParams(window.location.search);

    $.each(utmParams, function (_, param) {
        const value = urlParams.get(param);

        if (value) {
            setCookie(param, value);
            $('#' + param).val(value);
        } else {
            $('#' + param).val(getCookie(param));
        }
    });
});